export const drivingCategories = [
  { label: "A" },
  { label: "A1" },
  { label: "B" },
  { label: "BE" },
  { label: "B1" },
  { label: "C" },
  { label: "CE" },
  { label: "C1" },
  { label: "C1E" },
  { label: "D" },
  { label: "DE" },
  { label: "D1" },
  { label: "D1E" },
  { label: "M" },
  { label: "F" },
  { label: "G" },
  { label: "TPP" },
  { label: "OAut" },
];
